// yellow-green (high water line to zero meter contour)
export const S52_CO_DEPIT = {
  DAY: [115, 185, 142, 255],
  DUSK: [60, 92, 71, 255],
  NIGHT: [35, 52, 40, 255],
};

// medium/light blue (zero meter contour to shallow contour)
export const S52_CO_DEPVS = {
  DAY: [123, 193, 241, 255],
  DUSK: [55, 82, 98, 255],
  NIGHT: [30, 43, 49, 255],
};

// 	light/medium blue (shallow contour to selected safety contour)
export const S52_CO_DEPMS = {
  DAY: [152, 211, 237, 255],
  DUSK: [51, 68, 74, 255],
  NIGHT: [27, 35, 35, 255],
};

// pale/dark blue (safety contour to selected deep contour)
export const S52_CO_DEPMD = {
  DAY: [185, 225, 222, 255],
  DUSK: [37, 47, 44, 255],
  NIGHT: [22, 28, 25, 255],
};

// white/black (deeper than selected deep contour)
export const S52_CO_DEPDW = {
  DAY: [216, 244, 225, 255],
  DUSK: [0, 0, 0, 255],
  NIGHT: [0, 0, 0, 255],
};

export const S52_CO_DEPDW2 = {
  DAY: [0, 255, 0, 255],
  DUSK: [0, 0, 0, 255],
  NIGHT: [0, 0, 0, 255],
};

export const S52_FIRST_GROUP_COLORS = {
  S52_CO_DEPIT,
  S52_CO_DEPVS,
  S52_CO_DEPMS,
  S52_CO_DEPMD,
  S52_CO_DEPDW,
  S52_CO_DEPDW2
};
